import styled from 'styled-components';

import { Breakpoint, Color, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Markdown } from '../markdown/markdown.component';

import { ContainerProps } from './toast.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  border-radius: 4px;
  background-color: ${Color.Error500};
  padding: 12px;
  font-size: 14px;
  line-height: 18px;
  color: ${Color.White};
  bottom: 12px;
  right: 12px;
  max-width: 300px;
  z-index: ${ZIndex.Min};
  transition: 0.3s;
  opacity: 0;
  pointer-events: none;
  display: flex;
  justify-content: space-between;
  ${({ $visible }: ContainerProps): string | false => $visible && `
    opacity: 1;
  `}

  ${({ $destroyed }: ContainerProps): string | false => $destroyed && `
    display: none;
  `}

  ${({ $single }: ContainerProps): string | false => $single && `
    position: fixed;
    pointer-events: initial;
  `}

  @media ${Breakpoint.Mobile} {
    width: 100%;
    max-width: 100%;

    ${({ $single }: ContainerProps): string | false => $single && `
      width: calc(100% - 24px);
    `}
  }
`;

export const CloseButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledMarkdown: StyledComponent<typeof Markdown> = styled(Markdown)`
  a {
    color: ${Color.White};
    text-decoration: underline;
  }

  ul {
    margin: 10px 0;
    list-style-type: disc;
    list-style-position: inside;
  }
`;
